<template>
    <!--
            "text", "email", "phone", "number", "url", "date", "dropdown",
    -->
    <div class="contact-property-selector-inline" v-if="property">
        <template v-if="property.type === 'dropdown'">
            <a-select v-model="cloneValue" style="width: 100%">
                <a-select-option v-for="option of property.options" :key="option" :value="option">
                    {{ option }}
                </a-select-option>
            </a-select>
        </template>
        <template v-else>
            <a-input v-model="cloneValue" style="width: 100%" />
        </template>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "ContactPropertySelectorInline",
    props: {
        propertyId: {
            type: String,
            default: null,
        },
        value: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        cloneValue: null,
        property: null,
    }),
    computed: {
        ...mapState({
            properties: (state) => state.contactProperty.data,
        }),
    },
    mounted() {
        this.initProperty();
    },
    methods: {
        initProperty() {
            this.property = this.properties.find((item) => item._id === this.propertyId);
            this.cloneValue = !this.value
                ? this.property.type === "dropdown"
                    ? this.property.options[0]
                    : ""
                : this.value;
        },
    },
    watch: {
        properties: {
            handler() {
                this.initProperty();
            },
            deep: true,
        },
        cloneValue() {
            this.$emit("input", this.cloneValue);
        },
        value() {
            this.cloneValue = this.value;
        },
    },
};
</script>
